import api from '../../../api'
export default {

    acctUserGet(params){
        return api.get(`/accounting/`+params.url,{params})
    },
    acctUserPost(params){
        return api.post(`/accounting/`+params.url,params)
    },
}
